import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SrubUpService } from '../Services/ScrubUp.service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { MatSnackBar } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';

interface PackageFeature {
  FeatureID: number;
  FeatureName: string;
  FeatureValue: string;
  FeatureType: number;
  OrderNumber: number;
}

@Component({
  selector: 'app-subscription-update',
  templateUrl: './subscription-update.component.html',
  styleUrls: ['./subscription-update.component.scss'],
  providers: [SrubUpService]
})
export class SubscriptionUpdateComponent implements OnInit {

  loading = false;
  isImpersonateMode = false;
  planId: number;
  planName: string;
  subscriptionForm: FormGroup;
  features: PackageFeature[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private scrubUpService: SrubUpService,
    private appWideUser: AppWideUser,
    private token: Token,
    private cookieService: CookieService,
    private snackBar: MatSnackBar
  ) {
    this.subscriptionForm = this.formBuilder.group({
      features: this.formBuilder.array([])
    });
  }

  ngOnInit() {
    this.planId = +this.route.snapshot.paramMap.get('id');
    this.planName = this.route.snapshot.queryParamMap.get('name');

    if (this.token.access_token == undefined || this.token.access_token == null) {
      if (this.cookieService.check('Token')) {
        this.token = JSON.parse(this.cookieService.get('Token'));
      } else {
        this.router.navigate(['/login']);
        return;
      }
    }

    if (this.cookieService.check('impersonation')) {
      this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    }

    this.loadPlanDetails();
  }

  loadPlanDetails() {
    this.loading = true;
    this.scrubUpService.getPackageTypeByID(this.token, this.planId)
      .subscribe(
        (response) => {
          if (response && response.PackageTypesFeaturesList) {
            // Sort features by OrderNumber
            this.features = response.PackageTypesFeaturesList.sort((a: PackageFeature, b: PackageFeature) => a.OrderNumber - b.OrderNumber);
            console.log('Features after sorting:', this.features);
            this.buildForm();
          } else {
            console.error('Unexpected API response format:', response);
            this.snackBar.open('Unexpected data format from API', 'Close', { duration: 3000 });
          }
          this.loading = false;
        },
        (error) => {
          console.error('Error loading plan details:', error);
          this.loading = false;
          this.snackBar.open('Failed to load plan details', 'Close', { duration: 3000 });
        }
      );
  }

  buildForm() {
    const featuresArray = this.subscriptionForm.get('features') as FormArray;
    // Clear existing controls
    while (featuresArray.length !== 0) {
      featuresArray.removeAt(0);
    }

    console.log('Building form with features:', this.features);
    this.features.forEach(feature => {
      let value: any;
      if (feature.FeatureType === 1) {
        // Textbox - use FeatureValue as number
        value = parseInt(feature.FeatureValue) || 0;
      } else if (feature.FeatureType === 2) {
        // Switch - convert FeatureValue to boolean
        // "1" or 1 = ON, "0" or 0 = OFF
        value = feature.FeatureValue === '1' || feature.FeatureValue.toString() === '1';
      }
      console.log(`Adding form control for feature ${feature.FeatureName} with value ${value}`);
      featuresArray.push(this.formBuilder.control(value, Validators.required));
    });
    console.log('Form array after building:', featuresArray);
  }

  getFeatureType(feature: PackageFeature): number {
    return feature.FeatureType;
  }

  getFeatureValue(feature: PackageFeature): any {
    const index = this.features.indexOf(feature);
    const featuresArray = this.subscriptionForm.get('features') as FormArray;
    return featuresArray.at(index).value;
  }

  updatePlan() {
    if (this.subscriptionForm.invalid) {
      return;
    }

    this.loading = true;
    const formValue = this.subscriptionForm.get('features').value;

    // Create payload exactly as specified
    const payload = {
      PackageTypeID: this.planId,
      PackageTypesFeaturesList: this.features.map((feature, index) => ({
        FeatureID: feature.FeatureID,
        FeatureValue: feature.FeatureType === 2 ? (formValue[index] ? 1 : 0) : formValue[index],
        FeatureType: feature.FeatureType
      }))
    };

    console.log('Sending update payload:', payload);

    this.scrubUpService.updatePackageTypeFeaturesByID(this.token, payload)
      .subscribe(
        (response) => {
          console.log('Update response:', response);
          this.loading = false;
          this.snackBar.open('Plan updated successfully', 'Close', { duration: 3000 });
          this.router.navigate(['/layout/subscription']);
        },
        (error) => {
          console.error('Error updating plan:', error);
          this.loading = false;
          this.snackBar.open('Failed to update plan', 'Close', { duration: 3000 });
        }
      );
  }

  cancel() {
    this.router.navigate(['/layout/subscription']);
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/subscription/subscription-update.component.ts